module.exports = __webpack_public_path__ + "static/media/followme.cf93cefd.png";